


































































































    import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
    import ProfileIcon from "./ProfileIcon.vue";
    import Settings from "../settings/Settings.vue";
    import Notifications from "@share/notifications/Notifications.vue";
    import ToggleButton from "@common/vue-toggle-btn/toggle-btn.vue"
    import Points from "@share/points/Points.vue";
    import {NotificationDataHelper} from "@share/notifications/helpers/NotificationDataHelper";
    import HelpIcon from '../../../assets/svg/help.svg';
    import MessagesIcon from '../../../assets/svg/messages-icon.svg';
    import UsersIcon from '../../../assets/svg/users-icon.svg';
    import PointsIcon from '../../../assets/svg/points-icon.svg';
    import NotificationIcon from '../../../assets/svg/notification-icon.svg';
    import SupportIcon from '../../../assets/svg/support-icon.svg';
    import FavoritesIcon from '../../../assets/svg/favorites.svg';
    import BurgerMenuIcon from '../../../assets/svg/burger-menu.svg';
    import { InfoBlocksEnum } from '../../types/InfoBlocksEnum';
    import NavigationList from "./NavigationList.vue"

    import { EventBus } from "@common/EventBus";
    import {detectMob} from "@common/mobileHelper";
    import {Element} from "@api/models/Element";
    import HeaderPlayer from "./HeaderPlayer.vue";
    import { getImageUrl } from "@common/ImageUrlHelper";
    import { FavoritesState } from "@service/store/types/FavoritesState";
    import { readAllFavoritesAction, toggleFavoritesList } from "@service/store/favorites/actions";
    import { ticketSystemIsEnabled } from "@common/serviceParamsHelper";
	import { mainActions } from "@service/store/main/actions";
    import { IsMeetingsEnabled } from "@mixins/isMeetingsEnabled";
    import { ServiceName } from "@service/store/services/types";
	import { getDefaultToggleOptions } from "@common/vue-toggle-btn/helpers/optionsFabric";

    @Component({
        name: 'Navbar',
        components: { Notifications, ProfileIcon, Settings, HelpIcon, Points, FavoritesIcon,
            MessagesIcon, UsersIcon, PointsIcon, NotificationIcon, SupportIcon, NavigationList, HeaderPlayer, ToggleButton, BurgerMenuIcon }
    })
    export default class Navbar extends Mixins(IsMeetingsEnabled) {
        @Prop({required: true}) notificationDataHelper: NotificationDataHelper | null;

        isSettingsOpen = false;
        InfoBlocksEnum = InfoBlocksEnum;

        toggleOptions = getDefaultToggleOptions();

        private get isAdmin(): boolean {
          return this.$store.getters['isAdmin'];
        }

        get isRestrictedPartner() {
            return this.$store.getters["events/isRestrictedPartner"];
        }

        get ticketSystemIsEnabled() {
            return ticketSystemIsEnabled();
        }

        get firstName(): string {
            return this.$store.state.session?.profile?.firstName || '';
        }

        get isMobile(): boolean {
            return detectMob();
        }

        get unreaderChatsCount() {
            return this.$store.getters['chat/rooms/unreadCount'] || 0;
        }

        get favoritesState(): FavoritesState {
            return this.$store.state.favorites;
        }

        get invitesNotAnsweredCount() {
            return this.$store.state.invites.invitesNotAnsweredCount
        }

        get eventLogo() {
            const event = this.$store.getters['events/selectedEvent'];

            if (event && event.imageFileId) {
                return getImageUrl(this.$route.params.backend, event.imageFileId, 200)
            }
            return '';
        }

        get isShowPoints() {

            const serviceIsEnabled = this.$store.getters['services/serviceIsEnabled'](ServiceName.ratings, true);

            if (!serviceIsEnabled) {
                return serviceIsEnabled;
            }

            const pointsParams = this.$store.getters['events/selectedEventViewParam']('points', null);
            if (pointsParams && pointsParams.isShow) {
                return true;
            }
            return false;
        }

        get selectedEventId() {
            return this.$store.state.events.selected;
        }

        get showBurgerMenu() {
            return this.$store.state.events.list?.length > 1;
        }

        get selectedEventTitle() {
            return this.$store.getters["events/sortedListByEndDateDesc"]?.find((event: Element) => event.id === this.selectedEventId)?.title || '';
        }

        get showPlayer() {
            return this.$store.state.miniPlayer.showPlayer;
        }

        set showPlayer(showPlayer: boolean) {
            this.$store.dispatch("miniPlayer/setShowPlayer", showPlayer);
        }

        get isOnEditing() {
            return this.$store.state.isOnEditing;
        }

        toggleIsOnEditing() {
            this.$store.dispatch(mainActions.toggleIsOnEditing)
        }

        onPlayerClose() {
            this.showPlayer = false;
            this.$emit('stopBackground');
        }

        toggleFrontBlock(blockType: InfoBlocksEnum) {
            this.$emit('toggleFrontBlock', blockType);
        }

        toggleSettings() {
            this.$emit('toggleSettings');
        }

        toggleBurgerMenu() {
            this.$emit('toggleBurgerMenu');
        }

        get freshChatIsOpen() {
            return this.$store.state.services.freshChat?.isOpen;
        }

        get supportParams() {
            return this.$store.getters['services/getServiceParam']('supportChat', 'auth');
        }

        chatWithSupport() {
            if (this.supportParams.supporterUserId !== undefined) {
                EventBus.$emit('messageTo', this.supportParams.supporterUserId);
            }
            else {
                const freshChat = this.$store.state.services.freshChat;
                if (freshChat) {
                    freshChat.open();
                }
            }
        }

        get isHelpServiceEnabled() {
            return this.supportParams && (this.supportParams.supporterUserId !== undefined || this.supportParams.freshChatToken);
        }

        get messengerIsEnabled() {
            const isEnabled = this.$store.getters['services/getServiceParam']('messenger', 'isEnabled');
            return typeof isEnabled === "boolean" ? isEnabled : true;
        }

        get favoriteSessionsIsEnabled() {
            return this.$store.getters['services/serviceIsEnabled'](ServiceName.favoriteSessions, true);
        }

        get backend() {
            return this.$route.params.backend || this.$store.state.session?.backend;
        }

        get chatIsOpen() {
            return this.$route.hash.startsWith(`#${InfoBlocksEnum.chat}`);
        }

        get meetingsIsOpen() {
            return this.$route.hash.startsWith(`#${InfoBlocksEnum.meetings}`);
        }

        get ratingsIsOpen() {
            return this.$route.hash === `#${InfoBlocksEnum.rating}`;
        }

        get notificationsIsOpen() {
            return this.$route.hash === `#${InfoBlocksEnum.notifications}`;
        }

        get favoritesIsOpen() {
            return this.$route.hash === `#${InfoBlocksEnum.favorites}`;
        }

        @Watch('favoritesIsOpen')
        watchFavoritesIsOpen(value: boolean) {
            if(value && this.favoritesState.unreadedItems.length) {
                this.$store.dispatch(readAllFavoritesAction);
            }
            this.$store.dispatch(toggleFavoritesList, value)
        }
    }
